import iphone from "../../assets/iphone.png";
import screen from "../../assets/screens/2.png";
import googlePlay from "../../assets/google-play.svg";
import appStore from "../../assets/app-store.svg";
import "./style.css";

const Header = () => {
	return (
		<div className="container">
			<header id="Home">
				<div className="header">
					<div className="row">
						<div className="col-md-8 col-12">
							<div className="title-head">
								<p className="title">YUSUR APPLICATION</p>
								<p className="description">
									Everything You Need to Organize Funeral Ceremonies Easily and
									Gracefully.
								</p>
								<p className="download-now">Download App Now</p>
								<div className="download-apps">
									<img src={googlePlay} alt="googlePlay" />
									<img src={appStore} alt="appStore" />
								</div>
							</div>
						</div>
						<div className="col-md-4 col-12 d-flex justify-content-center justify-center-mobile">
							<div className="phone-head">
								<div className="phone">
									<img src={iphone} className="iphone" alt="iphone" />
									<img src={screen} className="screen" alt="screen" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
		</div>
	);
};
export default Header;
